module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "Int01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterSubtitle1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("By David Langford")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Sector Twelve General Hospital is one of the most charming and intelligently wish-fulfilling conceptions in science fiction, and its Irish creator James White—tall, bespectacled, balding, soft-spoken and eternally self-deprecating—was himself something of a charmer. Not merely a nice man, he was the cause of niceness in others. No one in the SF community could ever dream of being horrid to James.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("While others joined literary or fan factions and entangled themselves in heated feuding, James could be found at British conventions solemnly inducting qualified attendees—those who like himself were several inches over six feet—into the S.O.P.O.A.H. or Society Of Persons Of Average Height. A luckily short-sighted few had the further credentials required for admission to the inner circle, the S.O.P.O.A.H. (W.G.) (With Glasses). Naturally James continued to treat the inner circle, the outer circle and the great unwashed masses beyond with identical benevolence, which somehow lent all those other embattled in-groups the same aura of gentle silliness.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("James was and is much loved as a science fiction writer. I fondly remember scouring British bookshops in the 1960s for instalments of his Sector General space-hospital saga, which in those days was appearing in maddeningly brief instalments in E. John Carnell’s original anthology "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Writings in SF")]), _vm._v(", later edited by Kenneth Bulmer. The last to feature there was the first story in this volume, “Spacebird” from Bulmer’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Writings in SF 22")]), _vm._v(", published in 1973. British fans of Sector General had a long wait for this xeno")]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("biological extravaganza’s inclusion in the 1980 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ambulance Ship")]), _vm._v(". Americans had to wait longer still—until now, in fact—since the 1979 US version of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ambulance Ship")]), _vm._v(" omitted “Spacebird.”")])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As every SF reader should know, Sector Twelve General Hospital is a huge interstellar construction built in a spirit of glorious idealism by many co-operating galactic races, with its 384 levels equipped to simulate the home environment of any conceivable alien patient. Conceivable, that is, to the builders’ imaginations. From the outset James gleefully harassed his Sector General medics with a steady stream of inconceivables and seeming-impossibles, ranging in size from an intelligent virus and spacefaring barnacles, via beasties without hearts who must keep rolling forever to prevent their circulation from halting, and a levitating brontosaur called Emily, to “macro” life-forms like the miles-long Midgard Serpent which is discovered scattered through space in dismantled form and must be painstakingly reassembled, or the continent-sized inhabitant of planet Meatball whose treatment in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Major Operation")]), _vm._v(" requires not so much surgery as military action.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In short, Sector General is the definitive medical SF series. Its precursors include L. Ron Hubbard’s moderately dire "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ole Doc Methuselah")]), _vm._v(" stories and the competent hackwork of Murray Leinster’s Med Service tales. It may perhaps have helped inspire Piers Anthony’s amusing exploits of an interstellar dentist in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Prostho Plus")]), _vm._v(". Nothing else in the genre is at all comparable.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("To call these stories’ repeated pattern of medical mystery and elucidation a formula is far from being a put-down. As with detective fiction, the basic pattern offers scope for endless variations limited only by ingenuity and narrative sleight, with James’s lifelong fascination with medical techniques clearly visible throughout. There’s even room in Sector General for G. K. Chesterton’s favourite mystery trope of the Happy Surprise, whereby suitable illumination causes sinister and misleading clues to reverse themselves or cancel out, revealing that despite all appearances there has been no crime (or serious threat to health) at all.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("Several well-loved props run through the sequence. The most famous is the species classification system which sums up a creature’s shape and physiology in four terse letters. Theoretically this coding can extend to many further “decimal places,” but the first ")]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("four suffice for practical and narrative purposes. Earth-humans are DBDG and “similar” warm-blooded oxygen-breathers have similar codes, with teddy-bear Nidians and Orligians also being DBDG while the furry, caterpillar-shaped Kelgians are DBLF. Weirder creatures include chlorine-breathing PVSJs and psi-talented V-codes. One buried joke concerns the unfortunate Gogleskan species of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Healer")]), _vm._v(", classification FOKT, who are almost unable to prevent themselves from forming mindlessly destructive mobs. This, by intention, greatly tickled the local SF fan group in the traditionally tough city of Glasgow, Scotland: the Friends of Kilgore Trout.")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The classification scheme began as homage to E. E. “Doc” Smith’s perhaps unworkably human-centred version from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gray Lensman")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Children of the Lens")]), _vm._v(", in which true "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Homo sapiens")]), _vm._v(" is classed AAAAAA while the most alien monstrosities imaginable—the horrid Ploorans in their cryogenic winter metamorphosis—register as “straight Z’s to ten or twelve places.” It is a happy coincidence that James’s first-ever published words, in his and Walt Willis’s fanzine "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Slant")]), _vm._v(" 4, were firmly inserted into a contribution that was being horrid to Doc Smith: “[These opinions of the great Smith are not those of the typesetter, J. White.]”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nearly half a century later he was honoured with the 1998 Skylark Award, presented by the New England SF Society in memory of Doc Smith and his Lensmen, and so consisting of an absolutely enormous magnifying lens. James found this practical as well as decorative, since by then his sight was failing to the stage where he needed such a glass to read even large type on the computer screen.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("Besides demoting humans from AAAAAA to the modest DBDG, James distanced himself in other little ways from the traditional SF anthropocentrism of an era when John W. Campbell still stalked the earth. (It should be remembered that the first Sector General story appeared in 1957.) Smart and sympathetic aliens are foregrounded from the very beginning. Virtually all the hospital’s top medical consultants, the eccentric Diagnosticians, are nonhuman. When a roving ambulance ship is introduced, it’s named "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rhabwar")]), _vm._v(" after a great doctor from the history of its Tralthan FGLI builders. When "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rhabwar")]), _vm._v("’s first mission appears to be a simple rescue of boring old humans and someone remarks, “There will be no juicy extraterrestrial cases on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("this")]), _vm._v(" trip,” he is crushingly answered by a Kelgian nurse: ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("“To us, Earth-human DBDG’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" juicy extraterrestrials.” In three later novels beginning with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Code Blue—Emergency")]), _vm._v(" (1987), the viewpoint characters are aliens who are not only as likeable as the human medics but every bit as accident-prone. Real equality includes the equal right to make blazing mistakes.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Another notable and fruitful series prop is Sector General’s system of Educator tapes, which help prepare doctors for other-species surgery by uploading the skills of an expert from the relevant world. The dark side of this piece of narrative convenience is that a complete and often cantankerous e-t personality is loose in your head, objecting to your vile choice of food (a regular Sector General canteen sight is a Senior Physician eating “visually noncontroversial” sandwiches of uncertain content, with his eyes tight shut) and possibly imposing strange glandular urges. In the short “Countercharm,” series hero Senior Physician Conway uses a tape recorded from a randy Melfan ELNT, and finds himself distracted from vital operations by an uncontrollable case of the hots for his gorgeous Melfan pupil—who happens to be a giant crab.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The regular human cast includes wisecracking, problem-solving Conway (who for ages appeared to have no first name—very late in the series it’s revealed to be Peter); his busty girlfriend and eventual wife Nurse (later Pathologist) Murchison, whose forename I have yet to detect; and the irascible Chief Psychologist O’Mara, wielder of deadly sarcasm and—at his worst—a feared politeness. Reasons for O’Mara’s peculiarly blunt, abrasive nature and multispecies insight lie at the heart of the penultimate Sector General novel, the elegiac "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mind Changer")]), _vm._v(", which allows us inside this thorny character’s head for only the second time in the entire sequence.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("Meanwhile Conway’s closest friend is the universally popular Dr. Prilicla, a fragile GLNO e-t who resembles a giant and beautiful dragonfly, carries diplomacy to the point of fibbing since its empathic talent makes it cringe from hostile emotion, and likes to weave its canteen spaghetti into an edible cable to be chomped while hovering in mid-air. Sector General’s staff and wards contain countless further aliens, each with their own quirky charm—engaging stock characters in a comedy of humours shaped by exotic racial traits. It’s a running joke that the hottest hospital gossip concerns ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("sexual antics in the methane level whose ethereal, crystalline SNLU patients live at 120–140 degrees below zero.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Thus the sequence offers copious fun and a warm feeling of extended community in addition to its xenobiological cleverness. “Almost wilfully upbeat,” wrote John Clute in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Encyclopedia of Science Fiction")]), _vm._v(". What it also contains—showing clearly through transparent storytelling that puts on no literary airs—is the compassion and rare anger of a good man. From that first novella in 1957 to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Double Contact")]), _vm._v(" forty-two years later, it is repeatedly stressed that xenophobia in all its forms is a loathsome disease requiring salutary treatment. The Monitor Corps, this loose interstellar Federation’s tough but kindly police force, hates war and stamps it out ruthlessly with nonlethal weapons like intimidation and sleepy gas. At Sector General’s bleakest hour in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Surgeon")]), _vm._v(", when the hospital is besieged by a space fleet and under missile attack, the defending Monitors grit their teeth and accept that “fanatically tolerant” medical staff will—must—give enemy casualities the same degree of care as their own wounded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It’s impossible not to see these gentle stories’ deep horror of war as fuelled by the author’s revulsion at events in his home town of Belfast. Generally he downplayed his feelings, but the shades of melancholy emerged in his 1975 fanzine contribution “The Exorcists of IF,” which miraculously preserved a light touch while mourning the ghosts of an older IF (Irish Fandom) then partly sundered by the Troubles, and which has with some justice been called the finest piece of fan fiction ever written. It is collected in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The White Papers")]), _vm._v(" (1996).")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On a related note, I have a vivid memory of James at the 1992 British national SF convention “Illumination,” held in a Blackpool seafront hotel and featuring a hugely noisy fireworks display on the adjacent beach. Thunderous detonations of mortar shells could be felt as visceral jolts; the vibrations set off car alarms all around the hotel. Amid these terrific bangs and flashes and siren-wailings, James’s plaintive Irish voice murmured into my ear: “They’re trying to make me feel at home.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("A later Sector General volume makes a deadpan gesture to the death-or-glory school of military SF, with war and violence being ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("presented as a sick, enfeebled species’s last remaining means of sexual stimulation. The Marquis de Sade might recognize his own face in that mirror. One early story spoke wistfully of “the diagnosis and treatment of a diseased interstellar culture, entailing the surgical removal of deeply rooted prejudice and unsane moral values…” If only.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It’s worth noting that in the James White universe, outright villains are extraordinarily few. Even that “diseased culture” which despicably attacks the hospital (via armed forces duped into believing it a prison and torture chamber) is rotten only at the top, and reforms itself in the light of sweet reason. The most murderous-seeming threats within Sector General all prove to be confused innocents: examples include a traumatized, out-of-control pet, a pre-sentient saurian, and frightened alien children with odd biological defences.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("One of the few characters ever to have engaged in deliberate killing is Monitor Fleet Commander (later Sector Marshal) Dermod, who has spent his life expiating his role in the small but bloody conflict of “Occupation: Warrior” (1959), a story whose Sector General links were removed by an editor who thought it too grim for the series. Now Dermod’s colossal Emperor-class battleship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vespasian")]), _vm._v(" is chiefly called on for shows of force or vast rescue manoeuvres—as in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Major Operation")]), _vm._v(", where it literally has to hold a giant tourniquet, and the present volume’s “Combined Operation.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That underlying moral sense illuminates such later and slightly darker segments as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Healer")]), _vm._v(", where after all the fireworks of his brilliant diagnoses and miracle cures, Conway is kicked upstairs to try his hand at the full responsibilities of a Diagnostician and to tackle cases that can’t be solved with a single dazzling intuition. Instead he must brace himself for tougher tussles: with the grim evolutionary dilemmas of the Gogleskans who daren’t approach each other and the reflexively violent Protectors who cannot be approached, with terminal injuries and recognition of the need for triage after major accidents, with normally cheerful and ultra-tough Hudlar FROB space roustabouts who have been reduced to a pitiable state by post-transplant shock or crippling senility.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Before this chance of promotion, though, the lighter-hearted "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ambulance Ship")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sector General")]), _vm._v(" take Conway far away from the ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("massive presence of the hospital and its permanent staff, to investigate medical enigmas with no immediate resources but the tiny "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rhabwar")]), _vm._v(" team. This makes for a pleasant series of shorter adventures revisiting favourite auctorial themes.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Without too overtly giving away surprises, it can be said that most of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ambulance Ship")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sector General")]), _vm._v(" see our man working his way thoughtfully around two pet concepts which crop up elsewhere in the sequence. One is best phrased as a question: is there any inherent biological or physical handicap to space travel which sufficient intelligence and ingenuity cannot overcome? Series readers will remember that a certain immodest alien in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Major Operation")]), _vm._v(", whose deeply weird physiology should have trapped him for life on the sea bed, is first encountered as an orbiting astronaut.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stories building on this question in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ambulance Ship")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sector General")]), _vm._v(" confront the baffled but eventually insightful Conway with five even more extreme cases. How can the dream of space possibly apply to e-t species who are blind, or limbless, or utterly devoid of mechanical technology, or helpless prisoners within insensately violent host-bodies, or larger than the greatest monsters of Earth’s deep seas? Aha.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The stories’ other repeated issue is the cheeky challenging of a Sector General axiom: that cross-species infection is as a rule impossible and that Conway and friends therefore need never fear catching something awful from their patients. Three clever exceptions are presented, though not of the kind that disprove the rule. Gulfs of time, a common chemistry, and the established (through Prilicla) premise of psychic empathy all sneak around the apparent constraints. A fourth and particularly far-out possibility—already planted in the early "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Surgeon—")]), _vm._v(" becomes the heart of the medical mystery in the later novel "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Final Diagnosis")]), _vm._v(".")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("Among this volume’s shorts the odd man out is “Accident,” set before the building of Sector General and linking it to James’s moving war or antiwar story “Tableau,” which can be found in his 1970 collection "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Aliens Among Us")]), _vm._v(". An all too credible accident in a multi-species spaceport facility, and the resulting nightmare struggle with intractable wreckage in an increasingly toxic atmosphere, crystallize the need for medical and paramedical expertise that extends over many different physiologies and biochemistries. This plants the ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("seed of Sector General, and of the recurring notion—found also in James’s non-series stories—that being able to give medical assistance to a distressed alien brings a priceless bonus of goodwill to the ever-tricky SF situation of First Contact.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As already indicated, James White was a highly popular SF author and convention guest whom everyone liked and whose kindliness extended even to such loathed creatures (“straight Z’s to ten or twelve places”) as parodists and critics. I happen to know this, because in my wickedness I wrote both a Sector General parody and a critical essay on the series, and each time James replied with a letter too embarrassingly generous for even such an egotist as David Langford to quote.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His death from a stroke in 1999 came too soon—he was seventy-one—but was mercifully quick. A lot of us miss him badly. Reading the Sector General books yet again brings back so many happy memories. It’s hackneyed but entirely true to say that I envy readers who are meeting them for the first time.")])])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page14"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a78b6ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312877705_Int01.vue
// module id = 69
// module chunks = 0